<script>
  export let id, left, top, width, height, onDrop, isDroppable;
  let hovered = false;
  let error = false;

  const onDragEnter = (e) => {
    if (!onDrop) return;
    e.preventDefault();
    const [cardId, prevSlot] = e.dataTransfer.types[0].split("/");

    if (isDroppable(cardId, prevSlot)) {
      e.dataTransfer.dropEffect = "move";
      hovered = true;
    } else {
      e.dataTransfer.dropEffect = "";
      error = true;
    }
  };

  const onDragStart = (e) => {
      const [_cardId, prevSlot, enhanced] = e.dataTransfer.types[0].split("/");
      const cardId = _cardId.toUpperCase();
      let idStandard = ''.concat(cardId, '_player',);
      let idEnhanced = ''.concat(cardId, '_player', '_enhanced');
      let idSelected = idStandard;
      if (enhanced != 1) {
        idSelected = idStandard;
      } else {
        idSelected = idEnhanced;
      }
      window.GAME.tooltips[idSelected].close(idSelected);
  };

  const onDragLeave = () => {
    if (!onDrop) return;
    hovered = false;
    error = false;
  };
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div
  on:dragover={onDragEnter}
  on:dragstart={onDragStart}
  on:dragleave={onDragLeave}
  on:drop={(e) => {
    const [cardId, prevSlot] = e.dataTransfer.types[0].split("/");

    error = false;
    hovered = false;
    if (!isDroppable(cardId, prevSlot)) return;
    onDrop(e);
  }}
  class="slot"
  {id}
  style:left="{left}px"
  style:top="{top}px"
  style:width="{width}px"
  style:height="{height}px"
>
  <slot />
  <div class="overlay" class:hovered class:error />
</div>

<style>
  .slot {
    position: absolute;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    opacity: 0;
    z-index: 100;
  }

  .hovered {
    opacity: 1;
    background: rgba(255, 255, 255, 0.4);
  }
  .error {
    opacity: 1;
    background: rgba(255, 0, 0, 0.4);
  }
</style>
